import {theme} from "../../../../../utils";


export const styles = {
    gaByNumbersTitle: {
        ...theme.typography.montseratH1,
        fontWeight: 700,
        fontSize: "20px",
        paddingRight: "10px",
        lineHeight: "26px",
        color: theme.palette.primary.main
    },
    downloadBtnLabel: {
        ...theme.typography.montseratBodyRegular,
        fontSize: "16px",
        color: theme.palette.primary.main,
        textTransform: "capitalize"
    }
}